import { create } from 'zustand';

export interface ViewStateStore {
  open: boolean;
  toggle: () => void;
}

export const [useViewStateStore, ViewStateStoreApi] = create<ViewStateStore>(
  set => ({
    open: false,
    toggle: (): void => {
      set(state => (state.open = !state.open));
    }
  })
);
